import { render, staticRenderFns } from "./create-or-edit-symbol.vue?vue&type=template&id=5c4ecd60&scoped=true"
import script from "./create-or-edit-symbol.vue?vue&type=script&lang=js"
export * from "./create-or-edit-symbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ecd60",
  null
  
)

export default component.exports